import React, { useState, useEffect } from 'react';
import { ArrowRight } from 'lucide-react';
import Navbar from './Navbar';

const HeroSection = ({ onNavigate }) => {
  // Animation stages: 'initial' | 'expanding' | 'revealed'
  const [animStage, setAnimStage] = useState('initial');

  // Trigger animation sequence on initial load / refresh
  const triggerAnimation = () => {
    setAnimStage('initial');

    // Step 1 -> Step 2: Ultra-smooth, slow enlargement of center image
    const expandTimer = setTimeout(() => {
      setAnimStage('expanding');
    }, 400);

    // Step 2 -> Step 3: Reveal Navbar & inner Hero components smoothly after enlargement completes
    const revealTimer = setTimeout(() => {
      setAnimStage('revealed');
    }, 2200);

    return () => {
      clearTimeout(expandTimer);
      clearTimeout(revealTimer);
    };
  };

  useEffect(() => {
    triggerAnimation();
  }, []);

  const isExpanded = animStage === 'expanding' || animStage === 'revealed';
  const isRevealed = animStage === 'revealed';

  const handleConsultation = (e) => {
    e.preventDefault();
    if (onNavigate) {
      onNavigate('contact');
    }
  };

  const handleCustomerForm = (e) => {
    e.preventDefault();
    if (onNavigate) {
      onNavigate('customer-form');
    }
  };

  return (
    <div className={`hero-page-wrapper stage-${animStage}`}>
      {/* Floating Header Navbar */}
      <Navbar isVisible={isRevealed} currentPage="home" onNavigate={onNavigate} />

      {/* Hero Main Section */}
      <section className="hero-section-container">
        {/* Animated Hero Card (Expands from centered box to full hero container) */}
        <div className={`hero-card ${isExpanded ? 'hero-card-expanded' : 'hero-card-initial'}`}>

          {/* Background Image & Gradient Overlay */}
          <div className="hero-bg-image-wrapper">
            <picture>
              <source
                media="(max-width: 640px)"
                srcSet={process.env.PUBLIC_URL + '/images/Home/hero-bg1.jpeg'}
              />
              <img
                src={process.env.PUBLIC_URL + '/images/Home/hero-bg.jpeg'}
                alt="Happy Family Protected by Meena Insurance"
                className="hero-bg-img"
              />
            </picture>
            <div className={`hero-overlay ${isExpanded ? 'overlay-active' : ''}`} />
          </div>

          {/* Inner Content Layer (Reveals gently after expansion completes) */}
          <div className={`hero-content-layer ${isRevealed ? 'content-visible' : ''}`}>

            {/* Top Left: Category Floating Pills */}
            <div className="pill-tags-group">
              <span className="pill-tag">
                <span className="pill-dot">•</span> Insurance
              </span>
              <span className="pill-tag">
                <span className="pill-dot">•</span> Trusted
              </span>
              <span className="pill-tag">
                <span className="pill-dot">•</span> Security
              </span>
            </div>

            {/* Bottom Grid: Left Title & Right Details/CTAs */}
            <div className="hero-bottom-grid">

              {/* Left Column: Big Headline */}
              <div className="hero-headline-box">
                <h1 className="hero-title">
                  <span className="title-sans">SECURE </span>
                  <span className="title-serif-italic">TODAY.</span>
                  <br />
                  <span className="title-sans">PROSPER </span>
                  <span className="title-serif-italic">TOMORROW.</span>
                </h1>
              </div>

              {/* Right Column: Description & Action Buttons */}
              <div className="hero-actions-box">
                <p className="hero-description">
                  From family protection to MSME and corporate insurance, get expert
                  guidance to choose suitable solutions with confidence.
                </p>

                <div className="hero-cta-buttons">
                  <a
                    href="/contact"
                    className="btn-primary-quote"
                    onClick={handleConsultation}
                  >
                    <span>Get a Free Consultation</span>
                    <ArrowRight size={18} className="btn-arrow" />
                  </a>

                  <a
                    href="/customer-form"
                    className="btn-secondary-watch"
                    onClick={handleCustomerForm}
                  >
                    <span>Customer Form</span>
                    <ArrowRight size={18} className="btn-arrow" />
                  </a>
                </div>
              </div>

            </div>

          </div>

        </div>
      </section>
    </div>
  );
};

export default HeroSection;
